import { Button, Center, Image, Text, VStack } from '@chakra-ui/react';

import { BsPlusCircle } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';

interface CreateAssignmentStartPageProps {
  onCreateAssignment: () => void;
}

export default function CreateAssignmentStartPage({
  onCreateAssignment,
}: CreateAssignmentStartPageProps) {
  const { t } = useTranslation();

  return (
    <Center paddingTop={32}>
      <VStack spacing={0}>
        <Image
          src="/public/images/createAssignment.svg"
          alt={`${t('admin.assignments.create.createNewAssignment')}`}
          marginBottom={6}
        />

        <Text fontSize="24px" fontWeight={600}>
          {t('admin.assignments.create.createAssignment')}
        </Text>

        <Text fontSize="16px" fontWeight={400}>
          {t('admin.assignments.create.createAssignmentDescription')}
        </Text>

        <Text fontSize="16px" fontWeight={400}>
          <Text as="span" fontWeight={600}>
            {t('admin.assignments.create.addAutomations')}
          </Text>{' '}
          {t('admin.assignments.create.addAutomationsDescription')}
        </Text>

        <Button
          variant="warmNeutralDashedBorder"
          width="60%"
          marginTop={10}
          leftIcon={<BsPlusCircle />}
          onClick={onCreateAssignment}
        >
          {t('admin.assignments.create.newAssignment')}
        </Button>
      </VStack>
    </Center>
  );
}
